import appUtils, {isBlank} from "@/utils/util";

function isHttpUrl(url) {
  return (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("data:image/")
  );
}

export const imageUtils = (src, image, thumbnail = true) => {
  let headImg = appUtils.myImage
  if (image) {
    let imageUrl
    let isConcatenated = false
    if (isHttpUrl(image)) {
      imageUrl = image
    } else {
      imageUrl = headImg + src + image
      isConcatenated = true
    }
    // 如果需要缩略图，不是base64格式，且是拼接的链接时才添加OSS图片处理参数
    if (thumbnail && !image.startsWith('data:image/') && isConcatenated) {
      // 示例：调整为宽度200px，高度自适应，质量75%
      imageUrl += '?x-oss-process=image/resize,w_200/auto-orient,1/quality,q_75'
    }
    return imageUrl
  }
};
export const blhcFile = (src, image) => {
  let headImg = appUtils.myImage
  if (image) {
    let imageUrl
    if (isHttpUrl(image)) {
      imageUrl = image
    } else {
      imageUrl = headImg + src + image
    }
    return imageUrl
  }
};
export const bigFile = (src, image, width = 600) => {
  let headImg = appUtils.myImage;
  if (image) {
    let imageUrl;
    if (isHttpUrl(image)) {
      imageUrl = image;
    } else {
      imageUrl = headImg + src + image;
    }
    imageUrl += `?x-oss-process=image/resize,w_${width}/auto-orient,1/quality,q_85/format,webp`;
    return imageUrl;
  }
  return '';
};
export const blhcImage = (src, image, thumbnail = true) => {
  let headImg = appUtils.myImage
  if (image) {
    let imageUrl
    let isConcatenated = false
    if (isHttpUrl(image)) {
      imageUrl = image
    } else {
      imageUrl = headImg + src + image
      isConcatenated = true
    }
    // 如果需要缩略图，不是base64格式，且是拼接的链接时才添加OSS图片处理参数
    if (thumbnail && !image.startsWith('data:image/') && isConcatenated) {
      // 示例：调整为宽度200px，高度自适应，质量75%
      imageUrl += '?x-oss-process=image/resize,w_200/auto-orient,1/quality,q_75'
    }
    return imageUrl
  }
};
export const blhcImageCopy = (image) => {
  let headImg = "https://blhc806.oss-cn-hangzhou.aliyuncs.com/websiteImg/";
  if (image) {
    if (isHttpUrl(image)) {
      return image;
    } else {
      return headImg + image;
    }
  }
};
export const imgUrlToBase64 = (url) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject("请传入url内容");
    }
    if (/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(url)) {
      // 图片地址
      const image = new Image();
      // 设置跨域问题
      image.setAttribute("crossOrigin", "anonymous");
      // 图片地址
      image.src = url;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0, image.width, image.height);
        // 获取图片后缀
        const ext = url.substring(url.lastIndexOf(".") + 1).toLowerCase();
        // 转base64
        const dataUrl = canvas.toDataURL(`image/${ext}`);
        resolve(dataUrl || "");
      };
    } else {
      // 非图片地址
      reject("非(png/jpe?g/gif/svg等)图片地址");
    }
  });
};
export const imgTagAddStyle = (htmlstr) => {
  //正则匹配所有img标签
  //let regex0 = new RegExp("(i?)(\<img)([^\>]+\>)","gmi");
  //正则匹配不含style="" 或 style='' 的img标签
  let regex1 = new RegExp(
    "(i?)(<img)(?!(.*?style=['\"](.*)['\"])[^>]+>)",
    "gmi"
  );
  //给不含style="" 或 style='' 的img标签加上style=""
  htmlstr = htmlstr.replace(
    regex1,
    '$2 style="border: 0px; width: 60px;height:60px; display: block;"$3'
  );
  //正则匹配含有style的img标签
  // let regex2 = new RegExp("(i?)(\<img.*?style=['\"])([^\>]+\>)", "gmi");
  //在img标签的style里面增加css样式(这里增加的样式：display:block;max-width:100%;height:auto;border:5px solid red;)
  // htmlstr = htmlstr.replace(regex2, "$2border: 0px; width: 60px;height:60px; display: block;$3");
  return htmlstr;
};
export const blhcVideoImage = (src, image, s) => {
  let videoUrl;
  if (!isBlank(image)) {
    videoUrl =
      "https://www.lianlaoban.cn/myImage/" +
      src +
      image +
      "?x-oss-process=video/snapshot,t_" +
      s * 1000 +
      ",f_jpg,w_800,h_600";
  }
  return videoUrl;
};
